export type MfeState = 'error-loading-module' | 'module-loaded';

export interface BootstrapData {
  mfeStates: Record<string, MfeState>;
}

export const bootstrapData: BootstrapData = {
  mfeStates: {}
};
